export const orderStats = [
    "Registered",
    "Confirmed",
    "Processing",
    "Completed",
    "Failed",
    "Rejected",
    "Archived"
];

export const processingOrderStats = [
    "Registered",
    "Confirmed",
    "Processing"
];

export const completedOrderStats = [
    "Completed"
];

export const emptyOrderStats = [
    "Registered",
    "Confirmed"
];

export const orderTypes = [
    "INTERNAL",
    "B2B"
];

export const deliveryMethod = "Download";

export const validityDays = [
    1,
    3,
    5,
    10,
    30
];

export const defaultValidityDays = 3;

export const orderStateMapper = {
    "Registered": "REGISTERED",
    "Confirmed": "CONFIRMED",
    "Processing": "PROCESSING",
    "Completed": "COMPLETED",
    "Failed": "FAILED",
    "Rejected": "REJECTED",
    "Archived": "ARCHIVED"
};

export const paymentMethodMapper = {
    "Card": "CARD",
    "Bank Transfer": "BANKTRANSFER",
    "Quota": "QUOTA"
};

export const adminFeeDefault = 50.0;

export const adminFeeLimit = 300;

export const kneipName = "KNEIP";
export const name360T = "360T";
export const snapshotName = "SNAPSHOT";
export const ghrSingleIsinName = "CS_GHR_SI";